export const SOL = 0;
export const RAY = 1;
export const SRM = 2;
export const USDC = 3;
